'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var growthbookReact = require('@growthbook/growthbook-react');
var DocumentBody = require('@narvar/nth-bit-document-body');
var KitDynamicLayout = require('@narvar/nth-kit-dynamic-layout-next');
var PackEddPanel = require('@narvar/nth-pack-edd-panel');
var NotificationCenter = require('@narvar/nth-pack-notification-center');
var DynamicHeader = require('@narvar/nth-bundle-dynamic-header');
var Feedback = require('@narvar/nth-pack-feedback');
var BlockAsset = require('@narvar/nth-block-asset');
var HelpPill = require('@narvar/nth-block-help-pill');
var SectionDivider = require('@narvar/nth-block-section-divider');
var BroadcastBanner = require('@narvar/nth-block-broadcast-banner');
var GlobalStyleTag = require('@narvar/nth-bit-global-style-tag');
var CpCustomComponent = require('@narvar/nth-block-cp-custom-component');
var CustomComponent = require('@narvar/nth-block-custom-component');
var ItemsInThisShipment = require('@narvar/nth-pack-items-in-this-shipment');
var MoreInformation = require('@narvar/nth-pack-more-information');
var PickupLocation = require('@narvar/nth-pack-pickup-location');
var Shipments = require('@narvar/nth-pack-shipments');
var Empty = require('@narvar/nth-bit-empty');
var NarvarFooter = require('@narvar/nth-bundle-narvar-footer');
var ErrorBoundary = require('@narvar/nth-bit-error-boundary');
var DeliveryStatus = require('@narvar/nth-block-delivery-status-component');
var DriverDetails = require('@narvar/nth-block-driver-details-component');
var LocalDeliveryMap = require('@narvar/nth-block-local-delivery-map');
var GiftTracking = require('@narvar/nth-pack-gift-tracking');
var Chat = require('@narvar/nth-kit-chat');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var features = require('./features.js');
var PrefetchData = require('./PrefetchData.js');
var TrackPageTitle = require('./TrackPageTitle.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var DocumentBody__default = /*#__PURE__*/_interopDefaultLegacy(DocumentBody);
var KitDynamicLayout__default = /*#__PURE__*/_interopDefaultLegacy(KitDynamicLayout);
var PackEddPanel__default = /*#__PURE__*/_interopDefaultLegacy(PackEddPanel);
var NotificationCenter__default = /*#__PURE__*/_interopDefaultLegacy(NotificationCenter);
var DynamicHeader__default = /*#__PURE__*/_interopDefaultLegacy(DynamicHeader);
var Feedback__default = /*#__PURE__*/_interopDefaultLegacy(Feedback);
var BlockAsset__default = /*#__PURE__*/_interopDefaultLegacy(BlockAsset);
var HelpPill__default = /*#__PURE__*/_interopDefaultLegacy(HelpPill);
var SectionDivider__default = /*#__PURE__*/_interopDefaultLegacy(SectionDivider);
var BroadcastBanner__default = /*#__PURE__*/_interopDefaultLegacy(BroadcastBanner);
var GlobalStyleTag__default = /*#__PURE__*/_interopDefaultLegacy(GlobalStyleTag);
var CpCustomComponent__default = /*#__PURE__*/_interopDefaultLegacy(CpCustomComponent);
var CustomComponent__default = /*#__PURE__*/_interopDefaultLegacy(CustomComponent);
var ItemsInThisShipment__default = /*#__PURE__*/_interopDefaultLegacy(ItemsInThisShipment);
var MoreInformation__default = /*#__PURE__*/_interopDefaultLegacy(MoreInformation);
var PickupLocation__default = /*#__PURE__*/_interopDefaultLegacy(PickupLocation);
var Shipments__default = /*#__PURE__*/_interopDefaultLegacy(Shipments);
var Empty__default = /*#__PURE__*/_interopDefaultLegacy(Empty);
var NarvarFooter__default = /*#__PURE__*/_interopDefaultLegacy(NarvarFooter);
var ErrorBoundary__default = /*#__PURE__*/_interopDefaultLegacy(ErrorBoundary);
var DeliveryStatus__default = /*#__PURE__*/_interopDefaultLegacy(DeliveryStatus);
var DriverDetails__default = /*#__PURE__*/_interopDefaultLegacy(DriverDetails);
var LocalDeliveryMap__default = /*#__PURE__*/_interopDefaultLegacy(LocalDeliveryMap);
var GiftTracking__default = /*#__PURE__*/_interopDefaultLegacy(GiftTracking);
var Chat__default = /*#__PURE__*/_interopDefaultLegacy(Chat);

const KitDynamicTrackPage = ({
  renderHeader = null,
  transformLayout = null,
  customComponents = null,
  userAgentDevice
}) => {
  const titan = nthHookContextPage.useTitanAnalytics();
  growthbookReact.useFeatureIsOn('noop-feature');

  // need to call this to trigger `trackingCallback` and send attrs to gb
  // before chat component renders if we want to run any experiments
  growthbookReact.useFeatureIsOn('help_pill-chat');
  React.useEffect(() => {
    titan?.page({
      type: 'page',
      name: 'Dynamic Track',
      channel: 'web',
      context: {},
      properties: {
        url: window.location.href,
        title: document.title,
        narvar_product_context: 'track'
      }
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
  }, [titan]);
  const {
    state
  } = nthHookContextPage.usePageContext();
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      whiteSpace: 'pre-line'
    }
  }, /*#__PURE__*/React__default["default"].createElement(GlobalStyleTag__default["default"], null), /*#__PURE__*/React__default["default"].createElement(DocumentBody__default["default"], null), /*#__PURE__*/React__default["default"].createElement(TrackPageTitle["default"], null), /*#__PURE__*/React__default["default"].createElement(Chat.ChatProvider, null, /*#__PURE__*/React__default["default"].createElement(Chat__default["default"], null), /*#__PURE__*/React__default["default"].createElement(KitDynamicLayout__default["default"], {
    userAgentDevice: userAgentDevice,
    transformLayout: transformLayout,
    feature: options => {
      if (!options) {
        return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
      }

      // NOTE: `name` is of type `string`, but we want to treat it as a
      // feature and do an exhaustive match over it, but still handle when the
      // `string` does not match a feature enum.
      const feature = options.node.name;
      const renderFeature = () => {
        switch (feature) {
          case features["default"].DYNAMIC_HEADER:
            {
              if (!renderHeader) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
              return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(DynamicHeader__default["default"], {
                featureName: "narvarHeader"
                // TODO: refactor instead of disabling
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                ,
                key: features["default"].DYNAMIC_HEADER + options.node.id,
                templateRenderingContext: state,
                skipToContent: {
                  targetId: 'content',
                  scrollToTarget: false
                }
              }), /*#__PURE__*/React__default["default"].createElement("div", {
                id: "content",
                tabIndex: -1
              }));
            }
          case features["default"].EMPTY:
            {
              return /*#__PURE__*/React__default["default"].createElement(Empty__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].EMPTY + options.node.id
              });
            }
          case features["default"].NARVAR_FOOTER:
            {
              return /*#__PURE__*/React__default["default"].createElement(NarvarFooter__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].NARVAR_FOOTER + options.node.id,
                featureName: "narvarFooter",
                experienceHost: state.experienceHost
              });
            }
          case features["default"].BROADCAST_BANNER:
            {
              return /*#__PURE__*/React__default["default"].createElement(BroadcastBanner__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].BROADCAST_BANNER + options.node.id,
                featureName: "broadcastBanner"
              });
            }
          case features["default"].GIFT_SHARING:
            {
              return /*#__PURE__*/React__default["default"].createElement(GiftTracking__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].GIFT_SHARING + options.node.id,
                featureName: "giftTracking",
                userAgentDevice: userAgentDevice
              });
            }
          case features["default"].EDD_PANEL:
            {
              return /*#__PURE__*/React__default["default"].createElement(PackEddPanel__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].EDD_PANEL + options.node.id,
                layout: options.node.options && options.node.options.layout || undefined,
                featureName: "eddPanel",
                fixedPanelHeight: options.node.options && options.node.options.fixedPanelHeight || undefined
              });
            }
          case features["default"].SMS_NOTIFICATIONS:
            {
              return /*#__PURE__*/React__default["default"].createElement(NotificationCenter__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].SMS_NOTIFICATIONS + options.node.id,
                channel: NotificationCenter.Channels.SMS,
                layout: options.node.options && options.node.options.layout || undefined,
                featureName: "notificationCenter",
                fixedPanelHeight: options.node.options && options.node.options.fixedPanelHeight || undefined
              });
            }
          case features["default"].EMAIL_NOTIFICATIONS:
            {
              return /*#__PURE__*/React__default["default"].createElement(NotificationCenter__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].EMAIL_NOTIFICATIONS + options.node.id,
                channel: NotificationCenter.Channels.EMAIL,
                layout: options.node.options && options.node.options.layout || undefined,
                featureName: "emailNotifications",
                fixedPanelHeight: options.node.options && options.node.options.fixedPanelHeight || undefined
              });
            }
          case features["default"].DELIVERY_NOTIFICATIONS:
            {
              return /*#__PURE__*/React__default["default"].createElement(NotificationCenter__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].DELIVERY_NOTIFICATIONS + options.node.id,
                layout: options.node.options && options.node.options.layout || undefined,
                featureName: "deliveryNotifications",
                fixedPanelHeight: options.node.options && options.node.options.fixedPanelHeight || undefined
              });
            }
          case features["default"].BLOCK_ASSET:
            {
              const {
                fixedPanelHeight
              } = options.node.options || {};
              return /*#__PURE__*/React__default["default"].createElement(BlockAsset__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].BLOCK_ASSET + options.node.id,
                featureName: options.node.id ? `assets.${options.node.id}` : 'assets',
                featureId: options.node.id || '',
                fixedPanelHeight: fixedPanelHeight || undefined,
                localeCountry: state.localeCountry,
                localeLanguage: state.localeLanguage,
                templateRenderingContext: state
              });
            }
          case features["default"].FEEDBACK:
            {
              return /*#__PURE__*/React__default["default"].createElement(Feedback__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].FEEDBACK + options.node.id,
                featureName: "feedback",
                layout: options.node.options && options.node.options.layout || undefined,
                fixedPanelHeight: options.node.options && options.node.options.fixedPanelHeight || undefined
              });
            }
          case features["default"].HELP_PILL:
            {
              return (
                /*#__PURE__*/
                // FIXME: this is a hacky solution to moving the help pill up when
                // chat exists. there is no other way for these to talk to each other.
                React__default["default"].createElement(HelpPill__default["default"]
                // TODO: refactor instead of disabling
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                , {
                  key: features["default"].HELP_PILL + options.node.id,
                  featureName: "helpPill"
                })
              );
            }
          case features["default"].MORE_INFORMATION:
            {
              return /*#__PURE__*/React__default["default"].createElement(MoreInformation__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].MORE_INFORMATION + options.node.id,
                featureName: "moreInformation",
                layout: options.node.options && options.node.options.layout || undefined,
                fixedPanelHeight: options.node.options && options.node.options.fixedPanelHeight || undefined
              });
            }
          case features["default"].PICKUP_LOCATION:
            {
              return /*#__PURE__*/React__default["default"].createElement(PickupLocation__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].PICKUP_LOCATION + options.node.id,
                featureName: "pickupLocation",
                layout: options.node.options && options.node.options.layout || undefined,
                fixedPanelHeight: options.node.options && options.node.options.fixedPanelHeight || undefined
              });
            }
          case features["default"].SECTION_DIVIDER:
            {
              const {
                sectionDividerId
              } = options.node.options || {};
              return /*#__PURE__*/React__default["default"].createElement(SectionDivider__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].SECTION_DIVIDER + options.node.id,
                sectionDividerId: sectionDividerId || '',
                featureName: sectionDividerId ? `sectionDividers.${sectionDividerId}` : 'sectionDividers'
              });
            }
          case features["default"].ITEMS_IN_THIS_SHIPMENT:
            {
              return /*#__PURE__*/React__default["default"].createElement(ItemsInThisShipment__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].ITEMS_IN_THIS_SHIPMENT + options.node.id,
                featureName: "itemsInThisShipment",
                layout: options.node.options && options.node.options.layout || undefined,
                fixedPanelHeight: options.node.options && options.node.options.fixedPanelHeight || undefined
              });
            }
          case features["default"].SHIPMENTS:
            {
              return /*#__PURE__*/React__default["default"].createElement(Shipments__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].SHIPMENTS + options.node.id,
                featureName: "shipments",
                layout: options.node.options && options.node.options.layout || undefined,
                fixedPanelHeight: options.node.options && options.node.options.fixedPanelHeight || undefined
              });
            }
          case features["default"].YOUTUBE:
            {
              return /*#__PURE__*/React__default["default"].createElement(CustomComponent__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].YOUTUBE + options.node.id,
                componentId: options.node.id || '',
                featureName: "youtube",
                guestComponentSettings: options.node.options && options.node.options.customFeature
              });
            }
          case features["default"].DELIVERY_INSTRUCTIONS:
            {
              return /*#__PURE__*/React__default["default"].createElement(CustomComponent__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].DELIVERY_INSTRUCTIONS + options.node.id,
                componentId: options.node.id || '',
                featureName: "deliveryInstructions",
                guestComponentSettings: options.node.options && options.node.options.customFeature
              });
            }
          case features["default"].REDIRECT_TO_HOLD:
            {
              return /*#__PURE__*/React__default["default"].createElement(CustomComponent__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].REDIRECT_TO_HOLD + options.node.id,
                componentId: options.node.id || '',
                featureName: "redirectToHold",
                guestComponentSettings: options.node.options && options.node.options.customFeature
              });
            }
          case features["default"].PICKUP_POINT_DETAILS:
            {
              return /*#__PURE__*/React__default["default"].createElement(CustomComponent__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].PICKUP_POINT_DETAILS + options.node.id,
                componentId: options.node.id || '',
                featureName: "pickupPointDetails",
                guestComponentSettings: options.node.options && options.node.options.customFeature
              });
            }
          case features["default"].SCHEDULED_DELIVERY:
            {
              return /*#__PURE__*/React__default["default"].createElement(CustomComponent__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].SCHEDULED_DELIVERY + options.node.id,
                componentId: options.node.id || '',
                featureName: "scheduledDelivery",
                guestComponentSettings: options.node.options && options.node.options.customFeature
              });
            }
          case features["default"].PRODUCT_RECOMMENDATIONS:
            {
              return /*#__PURE__*/React__default["default"].createElement(CustomComponent__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].PRODUCT_RECOMMENDATIONS + options.node.id,
                componentId: options.node.id || '',
                featureName: "productRecommendations",
                guestComponentSettings: {
                  graphqlQuery: `
                          query GetProductRecommendationsSettings(
                            $retailerMoniker: String!
                            $versionName: String!
                            $localeLanguage: Language
                            $localeCountry: Country
                            $trackingType: String
                            $trackingStatus: String
                            $cache: Boolean
                          ) {
                            retailerTranslations(
                              retailerMoniker: $retailerMoniker
                              product: "narvarjs_translations"
                              localeLanguage: $localeLanguage
                              localeCountry: $localeCountry
                              versionName: $versionName
                              status: $trackingStatus
                              type: $trackingType
                              cache: $cache
                            ) {
                              productRecommendationsIframeTitle
                              productRecommendationsCarouselTitle
                            }
                            retailerTheme(
                              product: "narvarjs"
                              retailerMoniker: $retailerMoniker
                              versionName: $versionName
                              localeLanguage: $localeLanguage
                              localeCountry: $localeCountry
                              featureName: "productRecommendations"
                              cache: $cache
                            ) {
                              # Inherited styles
                              headersMediumNone
                              headersSmallNone
                              bodytextDefaultNone
                              iconsPrimaryNone
                              panelcontainerNoneNone

                              # Arrows
                              productrecsarrowcontainerNextNone
                              productrecsarrowcontainerPrevNone
                              productrecsarrowNoneDefault
                              productrecsarrowNoneDisabled
                              productrecsarrowNoneHover

                              # Title
                              productrecscarouseltitleNoneNone

                              # Dots
                              productrecsdotcontainerNoneNone
                              productrecsdotNoneActive
                              productrecsdotNoneDefault
                              productrecsdotNoneHover

                              # Recommendation Item Container
                              productrecsreccontainerNoneNone

                              # Recommendation Container Styles
                              productrecspanelcontainerNoneNone

                              # Recommendation Item All Text
                              productrecsrectextNoneNone

                              # Recommendation Item Image
                              productrecsrecimageNoneNone

                              # Recommendation Item Name
                              productrecsrectextNameNone

                              # Recommendation Item Price
                              productrecsrecpriceNoneNone
                              productrecsrecpricePriceNone

                              # Recommendation Item Brand
                              productrecsrectextBrandNone

                              # Recommendation Item Rating
                              productrecsrecratingcontainerNoneNone
                              productrecsrecratingstarEmptyNone
                              productrecsrecratingstarFullNone

                              # Recommendation Item Sale Price
                              productrecsrecpriceSaleNone
                            }
                            retailerSettings(
                              product: "narvarjs"
                              retailerMoniker: $retailerMoniker
                              versionName: $versionName
                              localeLanguage: $localeLanguage
                              localeCountry: $localeCountry
                              cache: $cache
                            ) {
                              globalScopeCSS
                              productRecommendations {
                                ... on ProductRecommendationsScript {
                                  type
                                  script
                                }
                                ... on ProductRecommendationsJson {
                                  type
                                  api {
                                    method
                                    body
                                    headers
                                    urlTemplate
                                  }
                                  itemsLookup
                                  itemsMapping {
                                    lookup
                                    type
                                    options {
                                      currency
                                      offset
                                    }
                                  }
                                  carouselSettings
                                }
                                ... on ProductRecommendationsMlEngine {
                                  type
                                  jsonApi: api {
                                    method
                                    body
                                    headers
                                    urlTemplate
                                  }
                                  jsonItemLookup: itemsLookup
                                  jsonItemMapping: itemsMapping {
                                    lookup
                                    type
                                    options {
                                      currency
                                      offset
                                    }
                                  }
                                  carouselSettings
                                }
                                ... on ProductRecommendationsCertona {
                                  type
                                  urlTemplate
                                  certonaSettings
                                  itemsLookup
                                  itemsMapping {
                                    lookup
                                    type
                                    options {
                                      currency
                                      offset
                                    }
                                  }
                                  carouselSettings
                                }
                              }
                            }
                          }
                        `,
                  ...(options.node.options && options.node.options.customFeature)
                }
              });
            }
          case features["default"].CUSTOM_COMPONENT:
            {
              return /*#__PURE__*/React__default["default"].createElement(CpCustomComponent__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].CUSTOM_COMPONENT + options.node.id,
                componentId: options.node.id || '',
                featureName: "customComponent"
              });
            }
          case features["default"].DELIVERY_STATUS:
            {
              return /*#__PURE__*/React__default["default"].createElement(DeliveryStatus__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].DELIVERY_STATUS + options.node.id,
                featureName: "deliveryStatus",
                fixedPanelHeight: options.node.options && options.node.options.fixedPanelHeight || undefined
              });
            }
          case features["default"].DRIVER_DETAILS:
            {
              return /*#__PURE__*/React__default["default"].createElement(DriverDetails__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].DRIVER_DETAILS + options.node.id,
                featureName: "driverDetails"
              });
            }
          case features["default"].DELIVERY_MAP:
            {
              return /*#__PURE__*/React__default["default"].createElement(LocalDeliveryMap__default["default"]
              // TODO: refactor instead of disabling
              // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
              , {
                key: features["default"].DELIVERY_MAP + options.node.id,
                featureName: "localDeliveryMap",
                fixedPanelHeight: options.node.options?.fixedPanelHeight ?? undefined
              });
            }
          default:
            {
              const Component = customComponents && customComponents[feature];
              if (Component) {
                return /*#__PURE__*/React__default["default"].createElement(Component, {
                  options: options
                });
              }
              return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
            }
        }
      };
      return /*#__PURE__*/React__default["default"].createElement(ErrorBoundary__default["default"], {
        errorContent: null
      }, renderFeature());
    }
  })));
};
const KitDynamicTrackPageWithProviders = ({
  apollo,
  analytics,
  growthbook,
  titanAnalyticsOptions,
  initialState,
  onUnauthenticatedRequest,
  userAgentDevice,
  ...rest
}) => /*#__PURE__*/React__default["default"].createElement(nthHookContextPage.PageProvider, {
  apollo: apollo,
  analytics: analytics,
  growthbook: growthbook,
  titanAnalyticsOptions: titanAnalyticsOptions,
  initialState: initialState,
  onUnauthenticatedRequest: onUnauthenticatedRequest,
  deviceType: userAgentDevice === 'Mobile' ? 'mobile' : 'desktop'
}, /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], null, /*#__PURE__*/React__default["default"].createElement(KitDynamicTrackPage, _extends__default["default"]({
  userAgentDevice: userAgentDevice
}, rest))));

exports["default"] = KitDynamicTrackPageWithProviders;
